import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faShieldAlt } from '@fortawesome/free-solid-svg-icons'
import moment from 'moment'
import { Typography, Box } from '@mui/material'



const sx = {
  root: {
    position: 'relative',
    height: 40,
    borderBottom: '1px solid #CCCBD9',
    marginBottom: 50,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    color: 'var(--primary)',
  }
}
const BusinessFormControls = ({ model, dirty, isSubmitting, user }) => {
  return (
    <Box sx={sx.root}>
      {user?.kybValidated !== undefined && (
        <Box display="flex" alignItems="center">
          <FontAwesomeIcon icon={faShieldAlt} style={{ marginRight: 10, height: '1.5rem', marginBottom: '20px' }} />
          <Typography sx={{ marginBottom: '20px', fontSize: '14px' }}>
            {model?.details.businessName || model?.company}
            {' - Verified by Markaaz™ on '}
            {moment(model?.claimedAt).format('MM/DD/YYYY')}
          </Typography>
        </Box>
      )}
    </Box>
  )
}

export default BusinessFormControls
